import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getConsent, onConsentChange } from '../services/consent';

/**
 * The reader firewall + consent gate, in one hook.
 *
 * Returns `false` (no ads) when:
 *   - the route is a manhua reader page (`/read/`) — HARD policy: ad networks ban
 *     ads next to scanlation/pirated content; this is account-fatal, so it's
 *     enforced in code, not just convention, and
 *   - the user has not granted ad consent.
 *
 * `<AdSlot>` calls this and renders null when it's false.
 */
export const useAdsAllowed = () => {
  const location = useLocation();
  const [consent, setConsentState] = useState(getConsent());

  useEffect(() => onConsentChange(setConsentState), []);

  const onReader = location.pathname.includes('/read/');
  return !onReader && consent === 'granted';
};

export default useAdsAllowed;
